import {
  CbhIcon,
  type CbhIconProps,
  type IconType,
} from "@src/appV2/redesign/system/ui-components";

import { TimeSlot } from "./Open/types";

interface TimeSlotIconProps extends Pick<CbhIconProps, "size" | "sx"> {
  timeSlot: TimeSlot;
  variant?: "filled" | "outlined";
}

export const iconTypeByTimeSlotFilled: Record<TimeSlot, IconType> = {
  [TimeSlot.AM]: "sun-filled",
  [TimeSlot.PM]: "sunset-filled",
  [TimeSlot.NOC]: "moon-filled",
};

export const iconTypeByTimeSlotOutlined: Record<TimeSlot, IconType> = {
  [TimeSlot.AM]: "sun-outlined",
  [TimeSlot.PM]: "sunset-outlined",
  [TimeSlot.NOC]: "moon-outlined",
};

export function TimeSlotIcon(props: TimeSlotIconProps) {
  const { timeSlot, variant = "filled", ...restProps } = props;

  const iconType =
    variant === "filled"
      ? iconTypeByTimeSlotFilled[timeSlot]
      : iconTypeByTimeSlotOutlined[timeSlot];

  return <CbhIcon type={iconType} {...restProps} />;
}
